module.exports = __webpack_public_path__ + "img/jd-university.2c2b0cc4.png";